<template>
  <div :class="$style.announcementWrapperContainer">
    <AnnouncementWrapper
      id="AnnouncementWrapperElem"
      :caretOffset="getCaretOffset"
      caretPointsTo="left"
      caretPosition="right"
      :class="sectionCollapsed ? $style.announcementCollapsed : $style.announcement"
      header="SSO Has Moved"
      :localStorageKey="$options.localStorageKey"
      mainActionText="Got It"
      :style="{ 'top': topCSS }"
      @main-action="destroyNavPanelScrollEventListener"
    >
      <ParagraphBody>
        SSO has been renamed to Applications and moved under Integrations!
        Configure any application for single sign-on, user provisioning with SCIM,
        or custom API connections.
      </ParagraphBody>

      <ParagraphBody>
        Learn more by going to
        <Link
          :class="$style.learnMoreLink"
          :href="$options.kbArticleUrl"
          isExternal
          isMatchText
          target="_blank"
          text="An Overview of Applications"
        />
      </ParagraphBody>
    </AnnouncementWrapper>
  </div>
</template>

<script>
import { Link, ParagraphBody } from '@jumpcloud/ui-components';

import AnnouncementWrapper from 'client/components/Announcement/AnnouncementWrapper.vue';
import KbArticleUrls from 'client/util/Constants/KbArticleUrls';
import LocalStorageConstants from 'client/util/Constants/LocalStorageConstants';

const { ssoToApplicationsAnnouncementDismissed } = LocalStorageConstants;

export default {
  name: 'SSOMovedAnnouncement',

  components: {
    AnnouncementWrapper,
    Link,
    ParagraphBody,
  },

  props: {
    sectionCollapsed: Boolean,
  },

  data: () => ({
    navPanelBodyRef: {},
    topCSS: '0',
  }),

  kbArticleUrl: KbArticleUrls.ssoToApplications,
  localStorageKey: ssoToApplicationsAnnouncementDismissed,

  computed: {
    getCaretOffset() {
      return this.sectionCollapsed ? 25 : 23;
    },
  },

  watch: {
    sectionCollapsed(collapsed) {
      this.updateAnnouncementPosition(collapsed);
    },
  },

  mounted() {
    // wait a tick for the announcement wrapper element to render
    this.$nextTick(() => {
      this.navPanelBodyRef = this.$parent?.$parent?.$refs?.navPanelBody;

      this.createNavPanelScrollEventListener();
    });
  },

  beforeDestroy() {
    this.destroyNavPanelScrollEventListener();
  },

  methods: {
    createNavPanelScrollEventListener() {
      this.navPanelBodyRef.addEventListener('scroll', this.navPanelScrollEventHandler);
    },

    destroyNavPanelScrollEventListener() {
      this.navPanelBodyRef.removeEventListener('scroll', this.navPanelScrollEventHandler);
    },

    navPanelScrollEventHandler() {
      let scrollDistance = -(this.navPanelBodyRef.scrollTop);

      if (this.sectionCollapsed) {
        scrollDistance -= 30;
      }

      this.setTopCSS(scrollDistance);
    },

    setTopCSS(topValue) {
      this.topCSS = `${topValue}px`;
    },

    updateAnnouncementPosition(collapsed) {
      const currentTopValue = parseInt(this.topCSS, 10);

      const newTopValue = collapsed
        ? currentTopValue - 20
        : currentTopValue + 20;

      this.setTopCSS(newTopValue);
    },
  },
};
</script>

<style module>
.announcement {
  left: 200px;
}

.announcementCollapsed {
  left: 5rem;
}

.announcementWrapperContainer {
  position: fixed;
  z-index: 1;
}

.announcementWrapperContainer .announcement .learnMoreLink:hover {
  color: var(--announcement-color);
}
</style>
